// This file re-exports everything from the refactored files
// to maintain compatibility with existing imports

export type { 
  ChurchPresence, 
  Language, 
  ChurchFunding, 
  Region 
} from './types/region-types';

// Import all region data
import { general_mexico_regions } from './mexico/general-regions';
import { base_regions } from './mexico/regions';

// Combine all regions
export const regions_mexico = [...base_regions, ...general_mexico_regions];

export { 
  getRegionColor, 
  getFundingPercentage, 
  getTotalPledges, 
  getTotalMissionaries, 
  getTotalChurchFunding
} from './utils/region-utils';

export { formatCurrency } from './utils/money-utils';

export { loadRegionData } from './regions-data';
